import React from "react"
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"


export const MyDropdown = ( inputs ) => {
    const {name, defaultValue, handleChange, id, values, disable } = inputs.inputs;
    return(
        <FormControl sx={{minWidth: '100px', maxWidth: '200px'}} variant='standard' disabled={disable}>
            <InputLabel id={id}>
              {name}
            </InputLabel>
            <Select
                labelId={id}
                label={name}
                value={defaultValue}
                onChange={(e) => handleChange(e)}
                sx={{
                    'select option': {
                        backgroundColor: '#f5f6fa'
                    }
                }}
            >
                {values.map(value => {
                    return (
                        <MenuItem value={`${value}`} key={value}>
                            {value}
                        </MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    )
}